<template>
  <layout-list-detail :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2" v-if="!creatingNew">
            <AccessibleElSelect
              v-model="form.groupingSelected"
              prop="groupingSelected"
              :options="groupingsForAccessibleSelect"
              :withFormItem="true"
              id-prefix="companies"
              @change="onChangeGroupingSelected"
            >
              <template slot="label">{{$t('grouping.groups_created')}}</template>
            </AccessibleElSelect>
          </div>

          <div class="lg:mb-2" v-if="creatingNew">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('grouping.nombre')}}
                <el-form-item prop="nombre">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.nombre"
                    maxlength='100'
                  />
                </el-form-item>
              </label>
            </div>
          </div>
        </el-form>
    </div>
    </template>
    <template slot="table-header" v-if="selectedGroup && !creatingNew">
      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('grouping.companies_by_group')}}</label>
    </template>
    <template slot="table-core" v-if="selectedGroup && !creatingNew">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags" v-if="selectedGroup && !creatingNew">
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component" v-if="selectedGroup && !creatingNew">
      <kendo-grid-component class="kendo-pointer-default"
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" :ariaHidden="true"/>
              Desvincular
          </base-button-item-list>
        </template>
      </base-table-select-actions>
      <base-footer>
        <template slot="actions">
          <base-button-responsive v-if="creatingNew" mode="secondary" :text="$t('app.cancel')" icon="cross" @click="cancelCreating" :loading="isGeneralLoading"/>
          <base-button-responsive v-else mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="creatingNew" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>

          <!-- <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('groups.duplicate')" icon='copy' @click='toggleDuplicateDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('app.edit_name')" icon='editpencil' @click='toggleEditNameDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode='primary' :text="$t('grouping.delete')" icon='trash' @click='toggleDeleteDialog' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="selectedGroup && !creatingNew" mode="primary" :text="$t('configurations.link_company')" icon="link" @click="golinkGroupingCompanies" :loading="isGeneralLoading"/> -->
          
          <base-table-select-actions-form 
            ref="baseTableSelectActionsFormGrouping"
            v-if="actions && actions.length > 0 && selectedGroup && !creatingNew"
            :baseDropDownVisible="actions.length > 0">
            <template slot="more">
              <span v-for="action in actions" :key="action.IdAccion">
                <base-button-item-list theme="dark" 
                  @click="handleAction(action)" 
                  :disabled="isGeneralLoading" 
                  :loading="isGeneralLoading">
                  <base-icon :name="action.Icono" class="mr-2" :ariaHidden="true"/>
                  <div class="w-72 text-left">
                    {{ action.Descripcion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>

          <base-button-responsive v-if="!creatingNew" mode='primary' :text="$t('app.import_groupings')" icon='import' @click='toggleImportGroupingCompanies' :loading='isGeneralLoading || loadingExcel' :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="!creatingNew" mode="primary" :text="$t('grouping.new_group')" icon="plus" @click="resetViewNew" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-generic-dialog
        :dialogOpen="showModalImportGroupingCompanies"
        @toggleDialog="toggleImportGroupingCompanies"
        @applyDialog="applyImportGroupingCompanies"
        @downloadTemplate="downloadTemplateGroupingCompanies"
        header="Importación de Agrupaciones de empresas" 
        :getClientActive="false"
        />
      <BaseElDialog
        title="Borrar agrupación"
        :visible.sync="showModalDelete"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-grouping')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-grouping">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModalDelete = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-text-dialog 
        :dialogOpen="showModalEditName" 
        @toggleDialog="toggleEditNameDialog" 
        @applyDialog="applyEditName"
        :header="$t('app.edit_name')"
        headerValue="Nuevo nombre de la agrupación" 
        />
      <input-text-dialog 
        :dialogOpen="showModalDuplicate" 
        @toggleDialog="toggleDuplicateDialog" 
        @applyDialog="applyDuplicateGrouping"
        header="Duplicar agrupación" 
        headerValue="Nombre de la nueva agrupación" 
        />
      <template-link-Companies-dialog 
        :title="$t('configurations.link_companies')"
        :dialogOpen="linkGroupingCompaniesDialog" 
        :clientId="this.$route.params.id" 
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler" />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </layout-list-detail>
</template>

<script>
import { bus } from '@/main'

import LayoutListDetail from '@/components/layout/DetailListLayout.vue'
import FilterPanel from '@/components/filters/CompaniesByGroupingFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { process } from '@progress/kendo-data-query'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import TemplateLinkCompaniesDialog from '@/components/TemplateLinkCompaniesDialog.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { getGroupingCompaniesPag } from '@/services/configurations/grouping/getGroupingCompaniesPag'
import { downloadGroupingCompaniesExcel } from '@/services/configurations/grouping/downloadGroupingCompaniesExcel'

import { linkGroupingCompanies } from '@/services/configurations/grouping/linkGroupingCompanies'
import { unlinkGroupingCompanies } from '@/services/configurations/grouping/unlinkGroupingCompanies'

import { newGroupingCompanies } from '@/services/configurations/grouping/newGroupingCompanies'
import { updateGroupingCompanies } from '@/services/configurations/grouping/updateGroupingCompanies'
import { deleteGroupingCompanies } from '@/services/configurations/grouping/deleteGroupingCompanies'
import { getAgrupacionesSimpleCompanies } from '@/services/configurations/grouping/getAgrupacionesSimpleCompanies'
import { duplicateGroupingCompanies } from '@/services/configurations/grouping/duplicateGroupingCompanies'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importGroupingCompanies } from '@/services/configurations/imports/importGroupingCompanies'
import { downloadTemplateGroupingCompanies } from '@/services/configurations/imports/downloadTemplateGroupingCompanies'

export default {
  /* eslint-disable camelcase */
  name: 'grouping-companies-view',
  components: {
    // ListLayout,
    LayoutListDetail,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    BaseElDialog,
    InputTextDialog,
    TemplateLinkCompaniesDialog,
    AccessibleElSelect,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 60,
      creatingNew: false,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      showModalDelete: false,
      showModalEditName: false,
      showModalDuplicate: false,
      loadingExcel: false,
      showModal: false,
      linkGroupingCompaniesDialog: false,
      searchView: false,
      activeName: 'es',
      spanish: true,
      header: {
        title: 'DETALLE DE AGRUPACIONES',
        icon: 'config',
        breadcrumb: null,
        url: 'configurations'
      },
      vuexnamespace: 'groupingcompanies',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      groupings: [],
      selected: [],
      showModalImportGroupingCompanies: false,
      form: {
        nombre: '',
        groupingSelected: null,
      },
      rules: {
        nombre: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      },
      processMessage: '¿Estás seguro que deseas borrar la agrupación actual?'
    }
  },
  computed: {
    actions () {
      let res = []
      if (this.selectedGroup && !this.creatingNew) {
        res = [
          { IdAccion: 1, Descripcion: this.$i18n.t('configurations.link_company'), Icono: 'link', Accion: this.golinkGroupingCompanies },
          { IdAccion: 3, Descripcion: this.labelBtnExcel, Icono: 'excelxls', Accion: this.exportExcel },
          { IdAccion: 4, Descripcion: this.$i18n.t('groups.duplicate'), Icono: 'copy', Accion: this.toggleDuplicateDialog },
          { IdAccion: 5, Descripcion: this.$i18n.t('app.edit_name'), Icono: 'editpencil', Accion: this.toggleEditNameDialog },
          { IdAccion: 6, Descripcion: this.$i18n.t('grouping.delete'), Icono: 'trash', Accion: this.toggleDeleteDialog },
        ]
      }
      return res
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    selectedGroup () {
      return this.form.groupingSelected
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isCreate: function () {
      return parseInt(this.$route.params.id) === -1
    },
    clienteId () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null
    },
    isSuperAdminView () {
      return this.clienteId
    },
    paramClientId () {
      return this.isSuperAdminView ? { idCliente: this.clienteId } : null
    },
    groupingsForAccessibleSelect () {
      return this.groupings.map(grouping => ({
        id: grouping.idAgrupacion,
        name: grouping.Nombre,
        value: grouping.idAgrupacion
      }))
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created: function () {
    // console.log('created: ')
  },
  mounted: async function () {
    const breadcrumbs = []
    if (this.isSuperAdminView) {
      breadcrumbs.push({
        path: 'configurations/clients/details',
        name: this.$i18n.t('app.client')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }

    await this.downloadData()
    breadcrumbs.push({ 
      path: this.isSuperAdminView ? 'configurations/grouping/companies' : 'configurations/grouping/companies/main', 
      name: this.$i18n.t('grouping.grouping_companies') 
    })
    this.header.url = this.isSuperAdminView ? 'configurations/clients/details' : 'configurations'
    this.header.breadcrumb = breadcrumbs
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.selectedGroup) await this.applyFilters()
  },
  methods: {
    handleAction (action) {
      try {
        action.Accion.call(this)
      } catch (error) {
        this.doFeedback()
        console.error(error)
      }
    },
    toggleImportGroupingCompanies () {
      this.showModalImportGroupingCompanies = !this.showModalImportGroupingCompanies
    },
    applyImportGroupingCompanies: async function (file, form) {
      this.applyGenericImport(file, form, importGroupingCompanies, this.toggleImportGroupingCompanies)
    },
    applyGenericImport: async function (file, form, importFunction, toggleFunction) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importFunction(file, { idCliente: this.clienteId })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          toggleFunction() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGeneric: async function (downloadFunction, nameFile = 'plantilla.xlsx') {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadFunction()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, nameFile)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGroupingCompanies: async function () {
      this.downloadTemplateGeneric(downloadTemplateGroupingCompanies, 'plantilla-importacion-agrupaciones-empresas.xlsx')
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    onChangeGroupingSelected () {
      if (this.selectedGroup) this.applyFilters()
    },
    toggleEditNameDialog () {
      this.showModalEditName = !this.showModalEditName
    },
    toggleDuplicateDialog () {
      this.showModalDuplicate = !this.showModalDuplicate
    },
    resetViewNew () {
      this.creatingNew = true
      // this.form.groupingSelected = null
    },
    cancelCreating () {
      this.creatingNew = false
      this.resetFormVal()
      this.downloadData()
    },
    downloadData: async function (idAgrupToSelect = null) {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getAgrupacionesSimpleCompanies(this.paramClientId)
        if (res.blnError === true) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.groupings = res.Respuesta
          // Preseleccionamos el primero
          if (res.Respuesta.length > 0) {
            this.form.groupingSelected = idAgrupToSelect || res.Respuesta[0].idAgrupacion
            this.onChangeGroupingSelected()
          } else {
            this.form.groupingSelected = null
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download }) {
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.newGroupingCompaniesHandler(formName)
    },
    resetForm: function () {
      this.form.nombre = ''
    },
    applyDuplicateGrouping: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { nombre: nombre, idAgrupacion: this.form.groupingSelected }
        const response = await duplicateGroupingCompanies(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.toggleDuplicateDialog()
          this.downloadData(response.Respuesta)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newGroupingCompaniesHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            Nombre: this.form.nombre,
            idCliente: this.clienteId
          }
          const response = await newGroupingCompanies(params)
          if (response.blnError) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Creado correctamente', 'success')
            this.redirectAfterCreating(response.Respuesta)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    redirectAfterCreating (idNewGrouping) {
      this.creatingNew = false
      this.resetForm()
      this.resetFormVal()
      this.downloadData(idNewGrouping)
    },
    resetFormVal () {
      this.$refs.ruleForm.resetFields()
    },
    applyEditName: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          NombreNuevo: nombre,
          idAgrupacion: this.form.groupingSelected,
          idCliente: this.clienteId
        }
        const response = await updateGroupingCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Actualizado correctamente', 'success')
          this.toggleEditNameDialog()
          this.downloadData(this.form.groupingSelected)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDeleteDialog () {
      this.showModalDelete = !this.showModalDelete
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idAgrupacion: this.form.groupingSelected,
        }
        const response = await deleteGroupingCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Borrado correctamente', 'success')
          this.downloadData()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      if (this.isSuperAdminView) this.$router.push({ name: 'configurations/clients/details' })
      else this.$router.push({ name: 'configurations' })
    },
    openPath: function (event) {
    },
    setWhatShow: function () {
      this.showAllRows = !this.showAllRows
    },
    tableSelected: function (val) {
      this.selected = val
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkGroupingCompaniesDialog = !this.linkGroupingCompaniesDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idAgrupacion: this.selectedGroup,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.estado ? data.estado.value : null,
        temporal: data.temporal ? data.temporal.value : null,
        emailGenerico: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdTag)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await downloadGroupingCompaniesExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'agrupacion-empresas.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      // console.log('applyFilters', data)
      const params = {
        idAgrupacion: this.selectedGroup,
        CIF: data.cif ? data.cif.value : null,
        nombre: data.name ? data.name.value : null,
        descargaAutomatica: data.automatic_download ? data.automatic_download.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        estado: data.estado ? data.estado.value : null,
        temporal: data.temporal ? data.temporal.value : null,
        emailGenerico: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        nombreAgrupacion: data.nombreAgrupacion ? data.nombreAgrupacion.value : null,
        codigoSede: data.codPGN ? data.codPGN.value : null,
        conPoderesDelegados: data.conPoderesDelegados ? data.conPoderesDelegados.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        // console.log('error', error)
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getGroupingCompaniesPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.respuesta.forEach(o => {
        o.DiasDescargaAutomatica = o.DiasDescargaAutomatica === null ? 0 : o.DiasDescargaAutomatica
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)

      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdUsuario)
      // }

      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (empresas) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idAgrupacion: this.selectedGroup, idCifEmpresas: [] }
        empresas.forEach(x => {
          payload.idCifEmpresas.push(x.IdCIFEmpresa)
        })
        const response = await unlinkGroupingCompanies(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Desvinculado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkGroupingCompanies: function () {
      this.linkGroupingCompaniesDialog = !this.linkGroupingCompaniesDialog
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    applyLinkHandler: async function (companies) {
      this.linkGroupingCompanies = false
      await this.linkHandler(companies)
      this.applyFilters()
    },
    linkHandler: async function (empresas) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idAgrupacion: this.form.groupingSelected, idCIFEmpresas: empresas }
        const response = await linkGroupingCompanies(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
          this.golinkGroupingCompanies()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
